

            import main             from './app/main.js';

            document.body.querySelector( '#loader' ).remove();
            document.body.classList.remove( 'loading' );
            main( document.body );

        